import React from 'react';
import PropTypes from 'prop-types';
import { withShowHide } from '@sparefoot/react-core/decorators';

import { Link } from 'components/core/Link';
import { Text } from 'components/core/Typography';
import ReviewExcerptPopover from './ReviewExcerptPopover';

import './ReviewExcerpt.scss';

export const enhance = withShowHide('popover');

export function ReviewExcerpt({
	facilityName,
	review,
	reviewUrl,
	popoverShowing,
	onShowPopover,
	onHidePopover,
}) {
	return (
		<div className="review-excerpt">
			<Text className="excerpt">{review.message}</Text>
			<Link
				className="full-review-link"
				href={reviewUrl}
				onMouseOver={onShowPopover}
				onMouseOut={onHidePopover}
				onFocus={onShowPopover}
				onBlur={onHidePopover}
				productClick
			>
				Full Review
				<ReviewExcerptPopover
					showing={popoverShowing}
					title={`What customers are saying about ${facilityName}`}
					review={review}
				/>
			</Link>
		</div>
	);
}

ReviewExcerpt.propTypes = {
	facilityName: PropTypes.string.isRequired,
	review: PropTypes.shape({
		nickname: PropTypes.string,
		rating: PropTypes.number.isRequired,
		message: PropTypes.string.isRequired,
	}).isRequired,
	reviewUrl: PropTypes.string.isRequired,
	popoverShowing: PropTypes.bool.isRequired,
	onShowPopover: PropTypes.func.isRequired,
	onHidePopover: PropTypes.func.isRequired,
};

export default enhance(ReviewExcerpt);
